import GetContractCDRs from './use-cases/GetContractCDRs';
import { IGetContractCDRs } from './interfaces/contract-cdr';
import AbstractModuleFactory from '@core/shared/module-factory';
import GetContractCellFix from './use-cases/GetContractCellFix';
import GetContractByIdUseCase from './use-cases/GetContractById';
import GetContractCDRTotal from './use-cases/GetContractCDRTotal';
import { IGetContractCellFix } from './interfaces/contract-cell-fix';
import { IGetContractCDRTotal } from './interfaces/contract-cdr-total';
import GetAllContractUseCase, { IGetAllContractUseCase } from './use-cases/GetAllContracts';

export class ContractModuleFactory extends AbstractModuleFactory {
  createGetAllContractUseCase(): IGetAllContractUseCase {
    return this.ensureInstance('GetAllContractUseCase', () => new GetAllContractUseCase());
  }

  createGetContractByIdUseCase(): GetContractByIdUseCase {
    return this.ensureInstance('GetContractByIdUseCase', () => new GetContractByIdUseCase());
  }

  /**
   * Use case that handle the contract cdrs query.
   */
  createGetContractCDRsUseCase(): IGetContractCDRs {
    return this.ensureInstance('GetContractCDRs', () => new GetContractCDRs());
  }

  /**
   * Use case that handle the contract cell fix query.
   */
  createGetContractCellFixUseCase(): IGetContractCellFix {
    return this.ensureInstance('GetContractCellFix', () => new GetContractCellFix());
  }

  /**
   * Use case that handle the contract cdr totals query.
   */
  createGetContractCDRTotalUseCase(): IGetContractCDRTotal {
    return this.ensureInstance('GetContractCDRTotal', () => new GetContractCDRTotal());
  }

  static new(): ContractModuleFactory {
    return new ContractModuleFactory();
  }
}

export default ContractModuleFactory.new();
